/**
 * engine API
 * engine API documentation
 *
 * OpenAPI spec version: 0.0.1
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import {Inject, Injectable, Optional} from '@angular/core';
import { HttpClient, HttpEvent, HttpHeaders, HttpParams, HttpResponse } from '@angular/common/http';
import {CustomHttpUrlEncodingCodec} from '../encoder';

import {Observable} from 'rxjs';

import {StepCountProjection} from '../model/stepCountProjection';
import {PageScenarioLogDto} from '../model/pageScenarioLogDto';
import {EmailStatsDto} from '../model/emailStatsDto';

import {BASE_PATH} from '../variables';
import {Configuration} from '../configuration';


@Injectable()
export class EngineScenarioService {

    protected basePath = 'https://dmp.airiane.com/services/engine';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * Get contact count per step
     * This endpoint retrieves the contact count for each step in a scenario
     * @param xDataStoreID X-DataStoreID
     * @param scenarioId scenarioId (MongoDB ID)
     * @param version version
     * @param status status (optional - null means no filter)
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getStepsCount(xDataStoreID: string, scenarioId: string, version: number, status?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<StepCountProjection>>;
    public getStepsCount(xDataStoreID: string, scenarioId: string, version: number, status?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<StepCountProjection>>>;
    public getStepsCount(xDataStoreID: string, scenarioId: string, version: number, status?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<StepCountProjection>>>;
    public getStepsCount(xDataStoreID: string, scenarioId: string, version: number, status?: string, observe: any = 'body', reportProgress = false ): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling getStepsCount.');
        }

        if (scenarioId === null || scenarioId === undefined) {
            throw new Error('Required parameter scenarioId was null or undefined when calling getStepsCount.');
        }

        if (version === null || version === undefined) {
            throw new Error('Required parameter version was null or undefined when calling getStepsCount.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (version !== undefined && version !== null) {
            queryParameters = queryParameters.set('version', <any>version);
        }
        if (status !== undefined && status !== null) {
            queryParameters = queryParameters.set('status', <any>status);
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<Array<StepCountProjection>>(`${this.basePath}/api/scenario/${encodeURIComponent(String(scenarioId))}/steps-count`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get scenario execution logs
     * This endpoint retrieves paginated execution logs for a scenario
     * @param xDataStoreID X-DataStoreID
     * @param scenarioId scenarioId (MongoDB ID)
     * @param version version
     * @param level log level filter (optional)
     * @param eventCode event code filter (optional)
     * @param stepPath step path filter (optional)
     * @param personalId personal ID filter (optional)
     * @param page page number (0-based)
     * @param size page size
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getLogs(xDataStoreID: string, scenarioId: string, version: number, level?: string, eventCode?: string, stepPath?: string, personalId?: number, page?: number, size?: number, observe?: 'body', reportProgress?: boolean): Observable<PageScenarioLogDto>;
    public getLogs(xDataStoreID: string, scenarioId: string, version: number, level?: string, eventCode?: string, stepPath?: string, personalId?: number, page?: number, size?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<PageScenarioLogDto>>;
    public getLogs(xDataStoreID: string, scenarioId: string, version: number, level?: string, eventCode?: string, stepPath?: string, personalId?: number, page?: number, size?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<PageScenarioLogDto>>;
    public getLogs(xDataStoreID: string, scenarioId: string, version: number, level?: string, eventCode?: string, stepPath?: string, personalId?: number, page = 0, size = 10, observe: any = 'body', reportProgress = false): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling getLogs.');
        }

        if (scenarioId === null || scenarioId === undefined) {
            throw new Error('Required parameter scenarioId was null or undefined when calling getLogs.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (version !== undefined && version !== null) {
            queryParameters = queryParameters.set('version', <any>version);
        }
        if (level !== undefined && level !== null) {
            queryParameters = queryParameters.set('level', <any>level);
        }
        if (eventCode !== undefined && eventCode !== null) {
            queryParameters = queryParameters.set('eventCode', <any>eventCode);
        }
        if (stepPath !== undefined && stepPath !== null) {
            queryParameters = queryParameters.set('stepPath', <any>stepPath);
        }
        if (personalId !== undefined && personalId !== null) {
            queryParameters = queryParameters.set('personalId', <any>personalId);
        }
        if (page !== undefined && page !== null) {
            queryParameters = queryParameters.set('page', <any>page);
        }
        if (size !== undefined && size !== null) {
            queryParameters = queryParameters.set('size', <any>size);
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<PageScenarioLogDto>(`${this.basePath}/api/scenario/${encodeURIComponent(String(scenarioId))}/logs`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }
    /**
     *
     *
     * @param xDataStoreID
     * @param scenarioId
     * @param version
     * @param partner
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public runScenarioById(xDataStoreID: string, scenarioId: string, version: number, partner: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public runScenarioById(xDataStoreID: string, scenarioId: string, version: number, partner: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public runScenarioById(xDataStoreID: string, scenarioId: string, version: number, partner: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public runScenarioById(xDataStoreID: string, scenarioId: string, version: number, partner: string, observe: any = 'body', reportProgress = false): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling runScenarioById.');
        }

        if (scenarioId === null || scenarioId === undefined) {
            throw new Error('Required parameter scenarioId was null or undefined when calling runScenarioById.');
        }

        if (version === null || version === undefined) {
            throw new Error('Required parameter version was null or undefined when calling runScenarioById.');
        }

        if (partner === null || partner === undefined) {
            throw new Error('Required parameter partner was null or undefined when calling runScenarioById.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (partner !== undefined && partner !== null) {
            queryParameters = queryParameters.set('partner', <any>partner);
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [];

        return this.httpClient.request<any>('get', `${this.basePath}/api/scenario/${encodeURIComponent(String(scenarioId))}/run/${encodeURIComponent(String(version))}`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     *
     *
     * @param xDataStoreID
     * @param scenarioId
     * @param version
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public runTestScenarioById(xDataStoreID: string, scenarioId: string, version: number, partner: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public runTestScenarioById(xDataStoreID: string, scenarioId: string, version: number, partner: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public runTestScenarioById(xDataStoreID: string, scenarioId: string, version: number, partner: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public runTestScenarioById(xDataStoreID: string, scenarioId: string, version: number, partner: string, observe: any = 'body', reportProgress = false): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling runTestScenarioById.');
        }

        if (scenarioId === null || scenarioId === undefined) {
            throw new Error('Required parameter scenarioId was null or undefined when calling runTestScenarioById.');
        }

        if (version === null || version === undefined) {
            throw new Error('Required parameter version was null or undefined when calling runTestScenarioById.');
        }

        if (partner === null || partner === undefined) {
            throw new Error('Required parameter partner was null or undefined when calling runTestScenarioById.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (partner !== undefined && partner !== null) {
            queryParameters = queryParameters.set('partner', <any>partner);
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [];

        return this.httpClient.request<any>('get', `${this.basePath}/api/scenario/${encodeURIComponent(String(scenarioId))}/run-test/${encodeURIComponent(String(version))}`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get email statistics for a scenario step
     * This endpoint retrieves aggregated email statistics for a specific step
     * @param xDataStoreID X-DataStoreID
     * @param scenarioId scenarioId (MongoDB ID)
     * @param stepPath step path (e.g., "0", "1.0")
     * @param version version (optional)
     * @param fromDate from date (optional)
     * @param toDate to date (optional)
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getEmailStats(xDataStoreID: string, scenarioId: string, stepPath: string, version?: number, fromDate?: string, toDate?: string, observe?: 'body', reportProgress?: boolean): Observable<EmailStatsDto>;
    public getEmailStats(xDataStoreID: string, scenarioId: string, stepPath: string, version?: number, fromDate?: string, toDate?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<EmailStatsDto>>;
    public getEmailStats(xDataStoreID: string, scenarioId: string, stepPath: string, version?: number, fromDate?: string, toDate?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<EmailStatsDto>>;
    public getEmailStats(xDataStoreID: string, scenarioId: string, stepPath: string, version?: number, fromDate?: string, toDate?: string, observe: any = 'body', reportProgress = false): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling getEmailStats.');
        }

        if (scenarioId === null || scenarioId === undefined) {
            throw new Error('Required parameter scenarioId was null or undefined when calling getEmailStats.');
        }

        if (stepPath === null || stepPath === undefined) {
            throw new Error('Required parameter stepPath was null or undefined when calling getEmailStats.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (stepPath !== undefined && stepPath !== null) {
            queryParameters = queryParameters.set('stepPath', <any>stepPath);
        }
        if (version !== undefined && version !== null) {
            queryParameters = queryParameters.set('version', <any>version);
        }
        if (fromDate !== undefined && fromDate !== null) {
            queryParameters = queryParameters.set('from', <any>fromDate);
        }
        if (toDate !== undefined && toDate !== null) {
            queryParameters = queryParameters.set('to', <any>toDate);
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        return this.httpClient.get<EmailStatsDto>(`${this.basePath}/api/scenario/${encodeURIComponent(String(scenarioId))}/email-stats`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }
}
